var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4231 11.0134L13.324 3.9143C13.1589 3.7492 12.9938 3.66666 12.7462 3.66666H4.49149C3.9962 3.66666 3.66602 3.99685 3.66602 4.49213V12.7468C3.66602 12.9945 3.74856 13.1596 3.91366 13.3247L11.0127 20.4237C11.508 20.919 12.0858 21.1667 12.7462 21.1667C13.4066 21.1667 14.067 20.919 14.4797 20.4237L20.4231 14.4803C21.4137 13.4898 21.4137 12.0039 20.4231 11.0134ZM19.2674 13.3247L13.324 19.2681C12.9938 19.5983 12.4986 19.5983 12.1684 19.2681L5.31696 12.4167V5.3176H12.416L19.2674 12.169C19.5976 12.4992 19.5976 12.9945 19.2674 13.3247ZM9.44432 8.61949C9.44432 8.37185 9.36177 8.20675 9.19668 8.04166C9.11413 7.95911 9.03158 7.87656 8.94903 7.87656C8.61885 7.71147 8.28866 7.79401 8.04102 8.04166C7.87592 8.20675 7.79337 8.37185 7.79337 8.61949C7.79337 8.70203 7.79337 8.86713 7.87592 8.94968C7.87592 9.03222 7.95847 9.11477 8.04102 9.19732C8.20611 9.36241 8.3712 9.44496 8.61885 9.44496C8.86649 9.44496 9.03158 9.36241 9.19668 9.19732C9.36177 9.03222 9.44432 8.86713 9.44432 8.61949Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.b983ca76.svg";
export { ForwardRef as ReactComponent };